import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { postRegistro } from "../../Servicios/Servicios";
import { GoogleMap, LoadScript, useJsApiLoader } from '@react-google-maps/api';
import './StylesRegistrar.css';
import { ClipLoader } from "react-spinners";
import { useSpinner } from "../../Component/spinner/spinner";
import bg from "../../assets/image/background.jpeg";
import background from "../../assets/image/loginBackgroundContenedor.png";
const refreshButtonStyle = {
  top: '10px',
  right: '10px',
  backgroundColor: '#fff',
  border: 'none',
  borderRadius: '8px',
  padding: '10px',
  cursor: 'pointer',
  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
  zIndex: 20,
};

const steps = [
  "Datos personales",
  "Credenciales",
  "Ubicación",
  "Redes sociales",
  "Confirmación",
];

const daysOfWeek = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

const timeOptions = [
  "08:00AM", "09:00AM", "10:00AM", "11:00AM",
  "12:00PM", "01:00PM", "02:00PM", "03:00PM",
  "04:00PM", "05:00PM", "06:00PM", "07:00PM",
  "08:00PM", "09:00PM", "10:00PM", "11:00PM", 
  "12:00AM", "01:00AM", "02:00AM", "03:00AM", 
  "04:00AM", "05:00AM", "06:00AM", "07:00AM"
];
const containerStyle = {
  width: '100%',
  height: '100%',
  position: 'relative',
};

export default function Registrar() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  useEffect( () => {
      // Verificar si ya hay un token de acceso
      const accessToken = localStorage.getItem("access");
      const refreshToken = localStorage.getItem("refresh");
      if (accessToken || refreshToken) {
        // Si hay un token, redirigir a la página de eventos
        navigate("/Eventos");
      }
    }, [ navigate ]);

  const [schedule, setSchedule] = useState(
    daysOfWeek.map(day => ({
      day,
      active: day === "Lunes", // Solo lunes activo por defecto
      times: day === "Lunes" ? [{ from: "11:00AM", to: "10:00PM" }] : []
    }))
  );

  const next = () => setStep((prev) => Math.min(prev + 1, steps.length - 1));
  const prev = () => setStep((prev) => Math.max(prev - 1, 0));

  // paso 0: 
  const next0 = ()=>{
    if (nombre && apellido && cel && tipoDocumento && documento) {
      next();
    } else {
      alert("Por favor, completa todos los campos.");
    }
  }
  // paso 1:
  const next1 = () => {
    if (nombreEstablecimiento && direccion && telefono && categoria && descripcion) {
      if (imagen) {
        next();
      } else {
        alert("Por favor, sube una imagen del establecimiento.");
      }
    }else {
      alert("Por favor, completa todos los campos.");
    }
  }
  // paso 2
  const next2 = () => {
    if (ubicacionInicial) {
      next();
    } else {
      alert("Por favor, selecciona una ubicación en el mapa.");
    }
  }
  //paso 3
  const next3 = () => {
    const horarioConcatenado = validarYFormatearHorario();

    if (horarioConcatenado) {
      setHorarios(horarioConcatenado);
      next(); // continúa con el flujo
    }else {
      alert("Por favor, activa al menos un día con un horario válido.");
    }
  }

  //paso 4
  const next4 = () => {
    
    if (email && password && repeatPassword) {
      if (password === repeatPassword) {
        handleRegister();
      } else {
        alert("Las contraseñas no coinciden.");
      }
    } else {
      alert("Por favor, completa todos los campos del la contraseña.");
    }
  }
  const validarYFormatearHorario = () => {
    const diasSemana = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

    const diasActivos = schedule
      .filter(d => d.active && d.times.length === 1)
      .map(d => ({
        dia: d.day,
        from: d.times[0].from,
        to: d.times[0].to
      }));

    if (diasActivos.length === 0) {
      alert("Debes activar al menos un día con un horario válido.");
      return null;
    }

    const grupos = [];
    let grupoActual = null;

    for (let i = 0; i < diasActivos.length; i++) {
      const actual = diasActivos[i];
      if (
        grupoActual &&
        actual.from === grupoActual.from &&
        actual.to === grupoActual.to &&
        diasSemana.indexOf(actual.dia) === diasSemana.indexOf(grupoActual.fin) + 1
      ) {
        grupoActual.fin = actual.dia;
      } else {
        if (grupoActual) grupos.push(grupoActual);
        grupoActual = {
          inicio: actual.dia,
          fin: actual.dia,
          from: actual.from,
          to: actual.to,
        };
      }
    }

    if (grupoActual) grupos.push(grupoActual);

    const formatearHora = (hora24) => {
      const [h, m] = hora24.split(":");
      const hora = parseInt(h);
      const sufijo = hora >= 12 ? "PM" : "AM";
      const hora12 = ((hora % 12) || 12) + "." + m;
      return `${hora12} ${sufijo}`;
    };

    const resultado = grupos.map(grupo => {
      const dias = grupo.inicio === grupo.fin ? grupo.inicio : `${grupo.inicio} - ${grupo.fin}`;
      return `${dias} ${formatearHora(grupo.from)} - ${formatearHora(grupo.to)}`;
    }).join("; ");

    return resultado;
  };

  const toggleDay = (index) => {
    const newSchedule = [...schedule];
    newSchedule[index].active = !newSchedule[index].active;
    if (!newSchedule[index].active) newSchedule[index].times = [];
    else newSchedule[index].times = [{ from: "11:00AM", to: "10:00PM" }];
    setSchedule(newSchedule);
  };

  const updateTime = (dayIndex, timeIndex, field, value) => {
    const newSchedule = [...schedule];
    newSchedule[dayIndex].times[timeIndex][field] = value;
    setSchedule(newSchedule);
  };

  const addTimeSlot = (dayIndex) => {
    const newSchedule = [...schedule];
    newSchedule[dayIndex].times.push({ from: "11:00AM", to: "10:00PM" });
    setSchedule(newSchedule);
  };


  const markerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10,
    pointerEvents: 'none',
  };
  const spinner = useSpinner();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [cel, setCel] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [documento, setDocumento] = useState("");
  const [nombreEstablecimiento, setNombreEstablecimiento] = useState("");
  const [direccion, setDireccion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [categoria, setCategoria] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [imagen, setImagen] = useState(null);
  const [ubicacionInicial, setUbicacionInicial] = useState(null);
  const [centroMapa, setCentroMapa] = useState(null);
  const mapRef = useRef(null);
  const [nombreArchivo, setNombreArchivo] = useState('');
  const [horarios, setHorarios] = useState(""); 
  const [loading, setLoading] = useState(false);
  
  const {isLoaded} = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyC4UwcnlEu-urUoO_1Gpf3fhpOGNPcqvKg', // reemplaza con tu API Key real
  });

  const obtenerUbicacion = () => {
// Verificar si el navegador soporta Geolocalización
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const coords = { lat: latitude, lng: longitude };
        setUbicacionInicial(coords);
        setCentroMapa(coords); // ← también actualizamos el centro
      },
      (error) => {
        console.error('Error obteniendo ubicación:', error);
        alert('No se pudo obtener tu ubicación');
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  }
  useEffect(() => {
    
    // Obtener la ubicación inicial al cargar el componente
    obtenerUbicacion();
  }, []);

  const onLoad = (map) => {
    mapRef.current = map;
  };

  // Cuando el usuario termina de mover el mapa
  const onIdle = () => {
    if (mapRef.current) {
      const nuevoCentro = mapRef.current.getCenter().toJSON();
      setCentroMapa(nuevoCentro);
    }
  };

  const handleRegister = () => {

    spinner.show();
    // Validar que las contraseñas coincidan
    if (password === repeatPassword) {
      let formData = {

        correoUsuario: email,
        contrasenaUsuario: password,
        numeroIdentificacionUsuario: documento,
        celularUsuario: cel,
        tipoIdentificacionUsuario: tipoDocumento,
        nombreUsuario: nombre,
        apellidoUsuario: apellido,
        nombreEstablecimiento: nombreEstablecimiento,
        latitud: centroMapa.lat.toFixed(6),
        longitud: centroMapa.lng.toFixed(6),
        tipoEstablecimiento: categoria,
        horario: horarios,
        imagen: imagen,
        telefono: telefono,
        descripcion: descripcion
      }
      const respo = postRegistro(formData);
      respo.then((response) => {
        if (response.success) {
          spinner.hide();
          alert("Registro exitoso");
          navigate("/")

        } else {
          spinner.hide();
          alert(response.message);

        }
      }).catch((error) => {
        spinner.hide();
        alert(`${error.response.data.message}`);
  
      })

      
    }else{
      spinner.hide();
      alert("Las contraseñas no coinciden.");
    }
  }
  const convertirImagenABase64 = (e) => {
    spinner.show();
    const file = e.target.files[0];
    if (file.size > 5 * 1024 * 1024) { // 5MB en bytes
      alert("El archivo excede el tamaño máximo permitido (5MB)");
      spinner.hide();
      return;
    }
    if (!file) return;
    setNombreArchivo(file.name);

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      const base64 = reader.result;
      setImagen(base64); // si estás usando useState
      spinner.hide();
    };

    reader.onerror = () => {
      console.error("Error al leer el archivo");
      spinner.hide();
    };
  };


  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4" style={{backgroundImage: `url(${bg})`}}>
      <div className="rounded-xl shadow-md w-full max-w-lg p-8"  style={{backgroundImage:`url(${background})`, backgroundRepeat: 'no-repeat'}}>
        <h2 className="text-center text-2xl font-bold text-white">Regístrate</h2>

        <p className="text-center text-sm text-white mt-1">
          Llena todos los campos para poder completar el registro a la plataforma
        </p>
        {/* Step Indicator */}
        <div className="flex justify-between mb-6">
          {steps.map((_, i) => (
            <div
              key={i}
              className={`w-6 h-6 rounded-full text-white text-sm flex items-center justify-center ${
                i <= step ? "" : "bg-gray-300"
              }`}
              style={i <= step ? { backgroundColor: "#4F60A8" } : {}}
            >
              {i + 1}
            </div>
          ))}
        </div>

        {/* Step Forms */}
        <div className="space-y-4">
          {step === 0 && (
            <>
              <div className="max-w-md mx-auto p-6">
                <div className="text-left text-white font-semibold mb-1">
                  Datos personales
                </div>
                <p className="text-sm text-white mb-4">
                  Ingresa tus datos personales, para tener tu información como usuario.
                </p>

                <div className="grid grid-cols-2 gap-4 mb-4 ">
                  <div className="grid grid-cols-1">
                    <label className="block text-sm font-medium text-white mb-1">
                      Nombre y Apellido (*)
                    </label>
                    <input
                      value={nombre ?? ''}
                      onChange={(e) => setNombre(e.target.value)}
                      type="text"
                      placeholder="Nombre"
                      className="input inputwhite"
                      
                    />
                  </div>
                  <div className="grid grid-cols-1">
                    <label className="block text-sm font-medium text-white mb-1">
                      Apellido (*)
                    </label>
                    <input
                      value={apellido ?? ''}
                      onChange={(e) => setApellido(e.target.value)}
                      type="text"
                      placeholder="Apellido"
                      className="input bg-gray-50 inputwhite"

                    />
                  </div>
                </div>
                <label className="block text-sm font-medium text-white mb-1">
                  Celular (*)
                </label>
                <input
                  value={cel ?? ''}
                  onChange={(e) => setCel(e.target.value)}
                  type="number"
                  placeholder="Número de celular"
                  className="input mb-4 no-spin inputwhite"
                />
                <br />
                <label className="block text-sm font-medium text-white mb-1 ">
                  Tipo de documento (*)
                </label>
                <select className="input mb-4 text-gray-500 inputwhite" value={tipoDocumento} onChange={(e) => setTipoDocumento(e.target.value)}>
                  <option className="text-gray-500" >Selecciona un tipo de documento</option>
                  <option className="text-gray-500" >Cédula</option>
                  <option className="text-gray-500" >Pasaporte</option>
                  <option className="text-gray-500" >Otro</option>
                </select>

                <br />
                <label className="block text-sm font-medium text-white mb-1">
                  Número de documento (*)
                </label>
                <input
                  value={documento ?? ''}
                  onChange={(e) => setDocumento(e.target.value)}
                  type="text"
                  placeholder="Número de documento o NIT"
                  className="input mb-6 inputwhite"
                />

                <button onClick={next0} style={{ backgroundColor: "#4F60A8" }}
                 className="w-full py-2 rounded-md from-indigo-500 to-indigo-600 text-white font-semibold shadow-md hover:opacity-90 transition">
                  Continuar
                </button>

              </div>
            </>
          )}

          {step === 1 && (
            <>
              <div className="max-w-md mx-auto p-6">
                <div className="text-left text-gray-700 font-semibold mb-1">
                  <span onClick={prev} className="text-indigo-600 cursor-pointer mr-2">{'<'}</span>
                  Datos del establecimiento 
                </div>
                <p className="text-sm text-gray-500 mb-4">
                  Ingresa los datos del establecimiento.
                </p>
                <label className="block text-sm font-medium text-white mb-1">
                  Nombre del establecimiento (*)
                </label>
                <input
                  value={nombreEstablecimiento ?? ''}
                  onChange={(e) => setNombreEstablecimiento(e.target.value)}
                  type="text"
                  placeholder="Nombre del establecimiento"
                  className="input mb-4 inputwhite"
                />
                <label htmlFor="file-upload" className="block text-sm font-medium text-white mb-1">
                  Imagen del establecimiento (*)
                </label>
                <label htmlFor="file-upload" style={styles.button}>
                  📎 Seleccionar archivo (*)
                </label>
                <br />
                <input 
                  id="file-upload"
                  accept="image/*"
                  onChange={(e) => convertirImagenABase64(e)}
                  type="file"
                  placeholder="Imagen del establecimiento"
                  className="mb-4 file-input inputwhite"
                  style={styles.hiddenInput}
                />
                {nombreArchivo && (
                  <span className="text-sm text-white">📄 {nombreArchivo}</span>
                )}
                <br />
                <label className="block text-sm font-medium text-white mb-1">
                  Descripción del establecimiento (*)
                </label>
                <input
                  value={descripcion ?? ''}
                  onChange={(e) => setDescripcion(e.target.value)}
                  type="text"
                  placeholder="Descripcion del establecimiento"
                  className="input mb-4 inputwhite"
                />
                <label className="block text-sm font-medium text-white mb-1">
                  Dirección del establecimiento  (*)
                </label>
                <input
                  value={direccion ?? ''}
                  onChange={(e) => setDireccion(e.target.value)}
                  type="text"
                  placeholder="Dirección"
                  className="input mb-4 inputwhite"
                />
                <label className="block text-sm font-medium text-white mb-1">
                  Teléfono del establecimiento (*)
                </label>

                <input
                  value={telefono ?? ''}
                  onChange={(e) => setTelefono(e.target.value)}
                  type="tel"
                  placeholder="Teléfono del establecimiento"
                  className="input mb-4 inputwhite"
                />

                <div className="mb-4">
                  <label className="block text-sm font-medium text-white mb-1">
                    Categoría a la que pertenece <span className="text-gray-400">(Selecciona lo que aplique)</span>
                  </label>
                  <div className="space-y-2 pl-1">
                    <label className="flex items-center space-x-2">
                      <input type="radio" name="categoria" value={categoria ?? ''} onChange={(e)=> setCategoria("Bar")} className="accent-indigo-600" />
                      <span style={styles.fontSizeTipo} className="text-white" >Bar</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <input type="radio" name="categoria" value={categoria ?? ''} onChange={(e)=> setCategoria("Restaurante")} className="accent-indigo-600" />
                      <span style={styles.fontSizeTipo} className="text-white" >Restaurante</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <input type="radio" name="categoria" value={categoria ?? ''} onChange={(e)=> setCategoria("Otro")} className="accent-indigo-600" />
                      <span style={styles.fontSizeTipo} className="text-white" >Otro</span>
                    </label>
                  </div>
                </div>

                <button onClick={next1} style={{ backgroundColor: "#4F60A8" }}
                 className="w-full py-2 rounded-md from-indigo-500 to-indigo-600 text-white font-semibold shadow-md hover:opacity-90 transition">
                  Continuar
                </button>
 
              </div>
            </>
          )}

          {step === 2 && (
            <>
                <div className="max-w-md mx-auto p-6">
                <h2 className="text-lg font-semibold text-white mb-1">
                  <span onClick={prev} className="text-indigo-600 cursor-pointer mr-2">{'<'}</span>
                  Confirma la ubicación de tu establecimiento 
                </h2>
                <p className="text-sm text-white mb-4">
                  Verifica que el punto marcado en el mapa sea el lugar donde se encuentra tu establecimiento.
                  Puedes mover el punto para más precisión.
                  <button onClick={obtenerUbicacion} style={refreshButtonStyle} title="Actualizar ubicación">
                  🔄
                </button>
                </p>
                <div className="w-full h-64 mb-6 rounded-lg overflow-hidden shadow-sm border">
                  {/* Puedes usar una API de mapas como Google Maps o Leaflet aquí */}
                  <div style={containerStyle}>
                    {!isLoaded ? <div>Cargando mapa...</div>:
                      <>
                        <GoogleMap
                            mapContainerStyle={{ width: '100%', height: '100%' }}
                            center={ubicacionInicial}
                            zoom={16}
                            onLoad={onLoad}
                            onIdle={onIdle}
                            options={{
                              disableDefaultUI: false,
                              zoomControl: true,
                              streetViewControl: false,
                            }}
                          />

                          {/* Ícono marcador en el centro */}
                          <img
                            src="https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png"
                            alt="marker"
                            style={markerStyle}
                          />

                          {/* Mostrar coordenadas del centro del mapa */}
                          {centroMapa && (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '10px',
                                left: '10px',
                                background: '#fff',
                                padding: '8px 12px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                              }}
                            >
                              <strong>Lat:</strong> {centroMapa.lat.toFixed(6)}<br />
                              <strong>Lng:</strong> {centroMapa.lng.toFixed(6)}
                            </div>
                          )}
                        </>
                      }
                    </div>
                </div>
                
                
                <button onClick={next2} style={{ backgroundColor: "#4F60A8" }} className="w-full py-2 rounded-md from-indigo-500 to-indigo-600 text-white font-semibold shadow-md hover:opacity-90 transition">
                  Continuar
                </button>

              </div>
            </>
          )}

          {step === 3 && (
            <>
              <div className="max-w-md mx-auto p-6">
                <h2 className="text-lg font-semibold text-white mb-1">
                  <span onClick={prev} className="text-indigo-600 cursor-pointer mr-2">{'<'}</span>
                  Horarios de atención (*)
                </h2>
                <p className="text-sm text-white mb-4">
                  Indica los horarios que tienes disponibles para atender a tus clientes.
                </p>

                {schedule.map((item, i) => (
                  <div key={item.day} className="mb-4 border rounded-lg p-3 shadow-sm">
                    <div className="flex items-center justify-between ">
                      <label className="flex items-center space-x-2 font-medium text-white">
                        <input
                          value={item.active ?? ''}
                          type="checkbox"
                          checked={item.active}
                          onChange={() => toggleDay(i)}
                          className="form-checkbox rounded text-indigo-600 inputwhite"
                        />
                        <span>{item.day}</span>
                      </label>
                    </div>

                    {item.active && (
                      <>
                        {item.times.map((slot, j) => (
                          <div key={j} className="flex space-x-2 mb-2">
                            <select
                              value={slot.from}
                              onChange={(e) => updateTime(i, j, "from", e.target.value)}
                              className="w-1/2 border rounded px-2 py-1 text-sm inputwhite"
                            >
                              {timeOptions.map(t => <option key={t}>{t}</option>)}
                            </select>
                            <select
                              value={slot.to}
                              onChange={(e) => updateTime(i, j, "to", e.target.value)}
                              className="w-1/2 border rounded px-2 py-1 text-sm inputwhite"
                            >
                              {timeOptions.map(t => <option key={t}>{t}</option>)}
                            </select>
                          </div>
                        ))}

                        <button 
                          onClick={() => addTimeSlot(i)} 
                          className="text-indigo-600 text-sm underline hover:text-indigo-800"
                        >
                          Agregar otro horario
                        </button>
                      </>
                    )}
                  </div>
                ))}

                <button onClick={next3} style={{ backgroundColor: "#4F60A8" }}
                 className="w-full py-2 mt-2 rounded-md from-indigo-500 to-indigo-600 text-white font-semibold shadow-md hover:opacity-90 transition">
                  Continuar
                </button>

              </div>
            </>
          )}

          {step === 4 && (
            <>
              {/* Formulario */}
                <div className="max-w-md mx-auto p-6">
                  <h2 className="text-lg font-semibold text-white mb-1">
                    <span onClick={prev} className="text-indigo-600 cursor-pointer mr-2">{'<'}</span>
                    <span className="text-white">Datos para el ingreso a la plataforma</span>
                  </h2>
                  <p className="text-sm text-white mb-4">
                    Ingresa los datos que te servirán para ingresar a la plataforma a partir de ahora.
                  </p>
                  <div>
                    <label className="block text-sm font-medium text-white mb-1">Correo electrónico</label>
                    <input
                      type="email"
                      placeholder="Correo electrónico (*)"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full border-b border-blue-300 focus:outline-none py-1 placeholder-gray-400 inputwhite"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-white mb-1">Contraseña</label>
                    <input
                      type="password"
                      placeholder="Contraseña (*)"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="w-full border-b border-blue-300 focus:outline-none py-1 placeholder-gray-400 inputwhite"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-white mb-1">Repetir contraseña</label>
                    <input
                      type="password"
                      placeholder="Repetir contraseña (*)"
                      value={repeatPassword}
                      onChange={(e) => setRepeatPassword(e.target.value)}
                      className="w-full border-b border-blue-300 focus:outline-none py-1 placeholder-gray-400 inputwhite"
                    />
                  </div>
                </div>

              {/* Botón */}
              <button
                onClick={next4} style={{ backgroundColor: "#4F60A8" }}
                className="w-full mt-6 py-2 from-indigo-500 to-indigo-600 text-white font-semibold rounded shadow hover:opacity-90 transition inputBackGray"
              >
                Finalizar registro
              </button>

              {/* Enlace inicio de sesión */}
            </>
          )}
        </div>
        <p className="text-center text-sm text-white mt-4">
          ¿Ya tienes cuentas?{" "}
          <Link to={"/"} className="text-blue-600 underline">
            Inicia sesión
          </Link>
        </p>
      </div>
    </div>
  );
}
const styles = {
  button: {
    display: 'inline-block',
    padding: '5px 11px',
    backgroundColor: '#1976d2',
    color: 'white',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'background 0.3s',
  },
  hiddenInput: {
    display: 'none',
  },
  fontSizeTipo:{
    fontSize: '12px',
  }
  
};
